import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import isClient from 'commons/isClient';
import isProd from 'commons/isProd';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const SCRIPT_ID = 'bazaarvoice-script';
const BV_CLIENT = 'joybird';
const BV_SITE_ID = 'main_site';
const BV_LOCALE = 'en_US';
const getBVEnvironment = () => isProd() ? 'production' : 'staging';
const getBVScriptUrl = () => {
  const env = getBVEnvironment();
  return `https://apps.bazaarvoice.com/deployments/${BV_CLIENT}/${BV_SITE_ID}/${env}/${BV_LOCALE}/bv.js`;
};

// pendingCallbacks: null = no load in progress; array = load in progress.
const bvScriptState = {
  pendingCallbacks: null
};
const loadBVScript = ({
  forceReload,
  callback
}) => {
  if (!isClient()) return;

  // If a script load is already in progress, queue the callback and return.
  if (bvScriptState.pendingCallbacks !== null) {
    if (callback) bvScriptState.pendingCallbacks.push(callback);
    return;
  }
  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript && forceReload) {
    existingScript.remove();
  }
  if (!document.getElementById(SCRIPT_ID)) {
    bvScriptState.pendingCallbacks = callback ? [callback] : [];
    const script = document.createElement('script');
    script.src = getBVScriptUrl();
    script.id = SCRIPT_ID;
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      const cbs = bvScriptState.pendingCallbacks || [];
      bvScriptState.pendingCallbacks = null;
      cbs.forEach(cb => cb());
    };
    script.onerror = () => {
      bvScriptState.pendingCallbacks = null;
      const failedScript = document.getElementById(SCRIPT_ID);
      if (failedScript) failedScript.remove();
    };
  } else if (callback) {
    callback();
  }
};
const useBazaarVoice = () => {
  const $ = _c(4);
  const [isReady, setIsReady] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const cleanup = {
        cancelled: false
      };
      loadBVScript({
        forceReload: isNewConsumerApp && !!document.getElementById(SCRIPT_ID),
        callback: () => {
          if (!cleanup.cancelled) {
            setIsReady(true);
          }
        }
      });
      return () => {
        cleanup.cancelled = true;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isReady) {
    t2 = {
      isReady
    };
    $[2] = isReady;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default useBazaarVoice;